import { Component, inject, OnInit } from '@angular/core';
import { ZiroIcons } from '../../models/ziro-icons.enum';
import { ButtonSizes, ButtonStyles } from '../../../button/button.component';
import { PhoneButtonSummary } from '../../phone-buttons/shared/phone-buttons.service';
import { ModalBodyClass } from '../../../modals/modal-body';
import { ZiroFormStateService } from '../../../forms/ziro-form-state.service';
import { PromptModalComponent } from '../../../modals/prompt-modal/prompt-modal.component';
import { ZiroFormConfig } from '../../../forms/ziro-forms-models';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../pipes/pipes.module';

export interface PhoneButtonLayoutConflictModalViewProperties {
  changeType: 'phone model' | 'phone button template';
  currentValue: string;
  proposedValue: string;
  currentButtonLayout: PhoneButtonSummary[];
  proposedButtonLayout: PhoneButtonSummary[];
  currentExpansionModules: string[];
  isButtonConflictPresent: boolean;
}

interface PhoneButtonConflictRow {
  current: PhoneButtonSummary;
  proposed: PhoneButtonSummary;
}

@Component({
  selector: 'ziro-phone-button-layout-conflict-modal',
  templateUrl: './phone-button-layout-conflict-modal.component.html',
  styleUrls: ['./phone-button-layout-conflict-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, PipesModule],
})
export class PhoneButtonLayoutConflictModalComponent extends ModalBodyClass implements OnInit {
  protected _ziroFormStateService: ZiroFormStateService;
  modalComponent = inject<PromptModalComponent<any>>(PromptModalComponent);

  protected formConfig: ZiroFormConfig;
  ziroIcons = ZiroIcons;
  ButtonStyles = ButtonStyles;
  ButtonSizes = ButtonSizes;
  isCopyUdpButton = false;

  buttonRows: PhoneButtonConflictRow[];

  /** Sometimes the layout will have a bunch of None buttons added to the end. We need to not display those. */
  private static _findActualLength(layout: PhoneButtonSummary[]): number {
    let length = 0;
    while (
      layout[length] &&
      !(layout[length].type === 'None' && layout.slice(length).every((button) => button.type === 'None'))
    ) {
      length++;
    }
    return length;
  }

  ngOnInit(): void {
    this.formConfig = {} as ZiroFormConfig;
    this.isCopyUdpButton = this.modalComponent.modalViewProperties?.isCopyUdpButton;
    if (this.modalComponent.modalViewProperties.isButtonConflictPresent) {
      const currentLayout = this.modalComponent.modalViewProperties.currentButtonLayout;
      const currentLayoutLength = PhoneButtonLayoutConflictModalComponent._findActualLength(currentLayout);
      const proposedLayout = this.modalComponent.modalViewProperties.proposedButtonLayout;
      const proposedLayoutLength = PhoneButtonLayoutConflictModalComponent._findActualLength(proposedLayout);
      const maxLength = Math.max(currentLayoutLength, proposedLayoutLength);

      this.buttonRows = new Array(maxLength);
      for (let i = 0; i < maxLength; i++) {
        this.buttonRows[i] = {
          current: currentLayoutLength > i && currentLayout[i],
          proposed: proposedLayoutLength > i && proposedLayout[i],
        };
      }
    }
  }

  submit(): Observable<boolean> {
    return new Observable((subscriber) => {
      subscriber.next(true);
      subscriber.complete();
    });
  }
}
